import { render, staticRenderFns } from "./AddNewProduct.vue?vue&type=template&id=30622cc7"
import script from "./AddNewProduct.vue?vue&type=script&lang=js"
export * from "./AddNewProduct.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./AddNewProduct.vue?vue&type=style&index=1&id=30622cc7&prod&lang=css"
import style2 from "../../../assets/styles/imgProduct.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports